var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54289 5.79289C8.93342 5.40237 9.56658 5.40237 9.95711 5.79289L15.4571 11.2929C15.8476 11.6834 15.8476 12.3166 15.4571 12.7071L9.95711 18.2071C9.56658 18.5976 8.93342 18.5976 8.54289 18.2071C8.15237 17.8166 8.15237 17.1834 8.54289 16.7929L13.3358 12L8.54289 7.20711C8.15237 6.81658 8.15237 6.18342 8.54289 5.79289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChevronRight);
export default __webpack_public_path__ + "static/media/line-chevron-right.7b4a022e92ed2d5d877fb7c363c4808d.svg";
export { ForwardRef as ReactComponent };